import { Button } from 'antd'
import styled from 'styled-components'

import { useAppThemeColors } from '../../../shared/hooks'

export const AnnotateSvgIcon = ({ fill }: { fill: string }) => (
  <svg width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      // eslint-disable-next-line max-len
      d="M14.1335 8.00033C14.1335 4.61298 11.3874 1.86686 8.00002 1.86686C4.61267 1.86686 1.86656 4.61298 1.86656 8.00033V14.1338H8.00002V15.3337H0.695984L0.675151 15.3252L0.666687 15.3044V8.00033C0.666687 3.95024 3.94993 0.666992 8.00002 0.666992C12.0501 0.666992 15.3334 3.95024 15.3334 8.00033C15.3334 12.0504 12.0501 15.3337 8.00002 15.3337V14.1338C11.3874 14.1338 14.1335 11.3877 14.1335 8.00033Z"
      fill={fill}
      fillOpacity="0.85"
    />
  </svg>
)
interface AnnotateButtonProps {
  isVisible: boolean
  isAnnotating: boolean
  onClick: () => void
}

export const AnnotateButton = ({ isVisible, isAnnotating, onClick }: AnnotateButtonProps) => {
  const themeColors = useAppThemeColors()
  const strokeColor = themeColors.colorPrimaryBorder

  return (
    <SAnnotationButton
      $isAnnotating={isAnnotating}
      style={{
        display: isVisible ? 'flex' : 'none',
      }}
      onClick={onClick}
    >
      <AnnotateSvgIcon fill={isAnnotating ? strokeColor : 'rgba(255, 255, 255, 0.85)'} />

      <SAnnotateText $isAnnotating={isAnnotating}>
        Annotate
      </SAnnotateText>
    </SAnnotationButton>
  )
}

const SAnnotationButton = styled(Button)<{ $isAnnotating: boolean }>`
  position: absolute;
  bottom: 110px;
  right: 24px;
  background-color:${({ $isAnnotating }) => ($isAnnotating ? '#111A2C' : '#1F1F1F')};
  border: 1px solid ${({ $isAnnotating }) => ($isAnnotating ? 'var(--ant-color-primary-border)' : '#424242')};
  display: flex;
  align-items: center;
  gap: 8px;
`

const SAnnotateText = styled.span<{ $isAnnotating: boolean }>`
  font-size: 14px;
  font-weight: 400;
  color: ${({ $isAnnotating }) => ($isAnnotating ? 'var(--ant-color-primary-border)' : 'rgba(255, 255, 255, 0.85)')};
`
